import { Component,Optional, OnInit } from '@angular/core';
import {ApiService} from '../services/api.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import * as $ from "jquery";
// import {NgForm} from '@angular/forms';
// import { ControlContainer, NgForm } from '@angular/forms';



@Component({
  selector: 'app-livewebinar',
  templateUrl: './livewebinar.component.html',
  styleUrls: ['./livewebinar.component.css']
})
export class LivewebinarComponent implements OnInit {
  model: any = {};
  isShowGroup:boolean = false;
  isShowOrganization:boolean = false;
  isShowErp:boolean = false;
  isShowSms:boolean = false;
  groupList: any;
  group:any;
  groupMemebr:any;
  groupMemberList: any;
  stuinfonew: any[];
  stuinfonewName: any[];
  departmentsList: any;
  department: any;
  usersList: any;
  dUser:any;
  courseList: any;
  course:any;
  sessionList: any;
  session: any;
  facultyList: any;
  takenBy:any;
  studentList: any;
  from: any;
  module:any;
  randomIDs: any;
  randomPasswords: any;
  groupDropdownSettings: any = {};
  selectedGroup: any;
  selectedGroupName: any;
  takenByList: any[];
  selectedID: any;
  dropdownSettings:any;
  selectedDeptName: any;
  takenByName:any;
  selectedCourseName:any;
  selectedSession:any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public ApiServiceCall: ApiService,
    private toastrService:ToastrService
    
  ) { 
    this.groupList = [];
    this.departmentsList = [];
    this.groupMemberList = [];
    this.usersList = [];
    this.courseList = [];
    this.sessionList = [];
    this.facultyList = [];
    this.studentList = [];
    this.selectedGroup = [];
    this.selectedGroupName = [];
    this.selectedID = [];
    this.dropdownSettings = {};
    this.takenByName;
    this.session;
    this.course;
    this.selectedCourseName;
    this.selectedSession;
  
  }
  getDropDownTextForGroupMember(webinarAttendee, object){
    const groupMemberObj = _.filter(object, function (o) {
        return (_.includes(webinarAttendee,o.webinarAttendee));
    });
    return groupMemberObj;
  }
  getDropDownTextForEmp(webinarAttendee, object){
    const EmpObj = _.filter(object, function (o) {
        return (_.includes(webinarAttendee,o.webinarAttendee));
    });
    return EmpObj;
  }
  
  getDropDownTextForCourse(id, object){
    const courseObj = _.filter(object, function (o) {
        return (_.includes(id,o.id));
    });
    return courseObj;
  }
  getDropDownTextForSession(id, object){
    const sessionObj = _.filter(object, function (o) {
        return (_.includes(id,o.id));
    });
    return sessionObj;
  }
  getDropDownTextForFaculty(id, object){
    const facultyObj = _.filter(object, function (o) {
        return (_.includes(id,o.id));
    });
    return facultyObj;
  }
  

  ngOnInit(): void {
    this.getAllGroupList();
    this.getAllDepartmentList();
    this.getAllCourseList();
    this.getAllSessionList();
    // this.getAllFacultyList();
    this.randomIDs = this.makeid(9);
    this.randomPasswords = this.makepassword(6);

    this.groupDropdownSettings = {
      singleSelection: false,
      idField: 'groupId',
      textField: 'groupName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      limitSelection:'3',
      allowSearchFilter: true
  };
  this.dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'deptName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true
};
    
  }




 deleteMemeber(index)
  {
    this.stuinfonew.splice(index,1);
    this.stuinfonewName.splice(index,1);
  }
  
  takenByGroupMember(gList:any){
 
    this.takenByName = this.getDropDownTextForGroupMember(this.takenBy, gList)[0].webinarAttendeeName;
    console.log('Vishnu'+ this.takenByName);
  }
  
  takenByEmp(empList:any){
    this.takenByName = this.getDropDownTextForEmp(this.takenBy, empList)[0].webinarAttendeeName;
    console.log('Vishnu'+ this.takenByName);
  }
  getCourseName(courseList:any){
    this.selectedCourseName = this.getDropDownTextForCourse(this.course, courseList)[0].name;
  }
  getSessionName(sessionList:any){
    this.selectedSession = this.getDropDownTextForSession(this.session, sessionList)[0].session;
    this.getAllFacultyList();
  }
  takenByFaculty(getFacultyList:any){
    this.takenByName = this.getDropDownTextForFaculty(this.takenBy, getFacultyList)[0].name;
  }


  onGroupSelect(gValue:any){
    console.log("Vishnu"+gValue);
    this.selectedGroup.push(gValue);
   
    // let item2 = this.selectedGroup.filter(i => i.groupId > 0 )[0].groupName;
    // this.selectedGroupName = item2;
    
    // console.log('Kumar.........'+this.selectedGroupName);
    // this.getGroupMemberListfor();
  }
  onGroupDeSelect(gValue:any){
    this.selectedGroup.splice(this.selectedGroup.indexOf(gValue),1);
    this.getGroupMemberListfor();
    // this.selectedGroupName = [];
    // this.takenByName = [];
  }
  
  
  getGroupMemberListfor(){
    this.takenByList = [];
    this.stuinfonew = [];
    this.stuinfonewName = [];   
    for(var i=0; i<this.selectedGroup.length;i++){
     
      var obj = {groupId: this.selectedGroup[i]['groupId'] };
    console.log(obj);
    // $(".loading-overlay").addClass("is-active");
    this.ApiServiceCall.showGroupList(obj).subscribe((data) => {
      // $(".loading-overlay").removeClass("is-active");
      console.log(data);
      this.groupMemberList = data.responseValue;          

      for(let i=0; i<this.groupMemberList.length; i++)
      {
        console.log(this.groupMemberList[i]['userId']);
        this.stuinfonew.push({"webinarAttendee": this.groupMemberList[i]['userId']});
        this.stuinfonewName.push({"webinarAttendee": this.groupMemberList[i]['userId'],"webinarAttendeeName": this.groupMemberList[i]['name']});
      }
     console.log(''+JSON.stringify(this.stuinfonew));
     console.log('Sandeep'+ JSON.stringify(this.stuinfonewName));


    });
    
  }
}


onItemSelect(item: any) {
  console.log(item);
   this.selectedID.push(item);
  
   this.getMemberListfor();
   
}

onItemDeSelect(item: any) {
  this.selectedID.splice(this.selectedID.indexOf(item),1);
  console.log('SelectedID', this.selectedID);
  this.getMemberListfor();

  // this.stuinfonewName = [];
  // this.selectedDPTname = [];
  // this.usersList = [];
  // this.takenByName = [];
  // this.stuinfonewName = [];
}

getMemberListfor()
  {
    this.takenByList = [];
    this.stuinfonew = [];
    this.stuinfonewName = [];
    console.log('sam');
    console.log(this.selectedID);
   
    for(var i=0; i<this.selectedID.length;i++){
      // this.selectedDPTname=this.selectedID[i]['id']; 
      var obj = { deptID: this.selectedID[i]['id']};
      // $(".loading-overlay").addClass("is-active");
      this.ApiServiceCall.getemployData(obj).subscribe((data) => {
        // $(".loading-overlay").removeClass("is-active");
        console.log(data['emp']);
        this.usersList = data['emp'];

        
        for(let ii=0; ii<this.usersList.length; ii++)
        {
          console.log(this.usersList[ii]['empID']);
          this.stuinfonew.push({"webinarAttendee": this.usersList[ii]['empID']});
          this.stuinfonewName.push({"webinarAttendee": this.usersList[ii]['empID'],"webinarAttendeeName": this.usersList[ii]['empName']});
          
        }
       console.log(''+JSON.stringify(this.stuinfonew));

      });
    }
    
    // this.selectedDeptName = JSON.stringify(this.module.erpDept);
  }
  



  getAllGroupList() {
    var obj = { instituteId: localStorage.getItem('userID') };

    this.ApiServiceCall.getGroupList(obj).subscribe((data) => {
      this.groupList = data.responseValue;
      console.log(data.responseValue);
    });
  }



  getAllGroupMemberList(group) {
    //console.log('sandeep'+this.getDropDownText(this.group, objList)[0].groupName);
        // this.selectValue = this.getDropDownTextForGroup(this.group, objList)[0].groupName;
        var obj = {groupId: group };
      
        this.ApiServiceCall.showGroupList(obj).subscribe((data) => {
         
          console.log(data);
          this.groupMemberList = data.responseValue;
          console.log("Vishnu" + JSON.stringify(this.groupMemberList));
    
          this.stuinfonew = [];
          this.stuinfonewName = [];
    
          for(let i=0; i<this.groupMemberList.length; i++)
          {
            console.log(this.groupMemberList[i]['userId']);
            this.stuinfonew.push({"webinarAttendee": this.groupMemberList[i]['userId']});
            this.stuinfonewName.push({"webinarAttendee": this.groupMemberList[i]['id'],"webinarAttendeeName": this.groupMemberList[i]['name']});
            
           
            
          }
         console.log(''+JSON.stringify(this.stuinfonew));
    
    
        });
        
        
      }
      getAllDepartmentList() {
        var obj = {};
        
        this.ApiServiceCall.getdeptData(obj).subscribe((data) => {
          this.departmentsList = data['dept'];
          // this.departmentsList = data['id'];
          // console.log('departmentsList' + JSON.stringify(this.departmentsList));
    
        });
    
    
      }
      
  getAllUsersList(department) {
    var obj = { deptID: department };
    this.ApiServiceCall.getemployData(obj).subscribe((data) => {

      console.log("Visnhu"+data['emp']);
      this.usersList = data['emp'];
      this.stuinfonew = [];
      for(let i=0; i<this.usersList.length; i++)
      {
        console.log(this.usersList[i]['empID']);
        this.stuinfonew.push({"webinarAttendee": this.usersList[i]['empID']});
        
      }
     console.log('SandeepSir'+JSON.stringify(this.stuinfonew));



    });


  } 

  getAllCourseList() {
    var obj = { userId: '11' };
    this.ApiServiceCall.getcouData(obj).subscribe((data) => {
      console.log(data.responseValue.courseMaster);
      this.courseList = data.responseValue.courseMaster;

    });
  }
  
  getAllSessionList() {
    var obj = { userId: '11' };
    this.ApiServiceCall.getsesData(obj).subscribe((data) => {
      console.log(data.responseValue.sessionMaster);
      this.sessionList = data.responseValue.sessionMaster;
    });

  }
  
   
  getAllFacultyList() {
    this.stuinfonew = [];
    this.stuinfonewName = [];
    var obj = { userId: '11' };
    this.ApiServiceCall.getfacData(obj).subscribe((data) => {
      console.log(data.responseValue.teacherMaster);
      this.facultyList = data.responseValue.teacherMaster;
      for(let i=0; i<this.facultyList.length; i++)
      {
        // console.log(this.studentList[i]['id']);
        this.stuinfonew.push({"webinarAttendee": this.facultyList[i]['id']});
        this.stuinfonewName.push({"webinarAttendee": this.facultyList[i]['id'],"webinarAttendeeName": this.facultyList[i]['name']});
      }

    });

  }
  getAllStudentList(session) {
    // this.selectedSession = this.getDropDownTextForSession(this.session, getSessionList)[0].session;
    // var obj = { userId: '11', courseId: this.course, sessionId: this.session };
    var obj = {userId: '11', courseId: this.course, sessionId: session };
    this.ApiServiceCall.getstuData(obj).subscribe((data) => {
      console.log(data);
      this.studentList = data.responseValue.studentList;
      this.stuinfonew = [];
      this.stuinfonewName = [];
      for(let i=0; i<this.studentList.length; i++)
      {
        console.log(this.studentList[i]['id']);
        this.stuinfonew.push({"webinarAttendee": this.studentList[i]['id']});
        this.stuinfonewName.push({"webinarAttendee": this.studentList[i]['id'],"webinarAttendeeName": this.studentList[i]['name']});
      }
     console.log(''+JSON.stringify(this.stuinfonew));

     console.log('Vishnu'+JSON.stringify(this.stuinfonewName));

    });
  }

  onSubmit(){
    var obj = {
      eventName : this.model.eventTitleLW,
      roomName: 'Webinar',
      startDateTime: this.model.startDateLW+ ' ' + this.model.startTimeLW + ':00',
      endDateTime: this.model.endDateLW + ' ' + this.model.endTimeLW + ':00',
      note : this.model.noteLW,
      // takenBy : this.takenById,
      takenBy : this.takenBy,
      webinarAttendeeList : JSON.stringify(this.stuinfonew),
      userId : localStorage.getItem('userID'),
      isLive: 1,
      groupId:null
      // createdBy:localStorage.getItem('userID'),
      
  };
  console.log(obj);
  $('.loading-overlay').addClass('is-active');
  this.ApiServiceCall.createWebinar(obj).subscribe((data) => {
    $('.loading-overlay').removeClass('is-active');

  console.log(data.responseMessage);
  alert('success');
  this.toastrService.success('Success!!');

  });
  
  }





  // onSubmit(){
    
  //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.model));

  // }
  showGroup(){
    this.isShowGroup = true;
    this.isShowOrganization = false;
    this.from = 'Group';
  }
  showOrganization(){
    this.isShowOrganization = true;
    this.isShowGroup = false;
    this.isShowErp = false;
    this.isShowSms = false;
    this.from = 'Organization';
  }
  showErp(){
    this.isShowErp = true;
    this.isShowSms = false;
    this.module = 'ERP'
    
  }
  showSms(){
    this.isShowSms = true;
    this.isShowErp = false;
    this.module = 'SMS'
    
  }
  makeid(length) {
    var result = '';
    var characters = '0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  makepassword(length) {
    var result = '';
    var characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

}
